import { createContext } from "react";

const slugContext = createContext({ slug: '' })

export default slugContext
